<template>
	<div
		class="nejpripo-data"
	>
		<span class="company-name"> NejPřipojení: </span>
		<div v-if="loading">
			<tile :loading="loading" :height="'4'" :width="'4'" class="loading-icon"></tile> 
		</div>
		<div 
			v-else
			v-show="basic.show"
			class="nejpripo-vysledek cetin-vysledek-card zmensit"
			v-for="(basic, basicIndex) of results"
			:key="basicIndex"
		>
			<div v-if="basic.hasOwnProperty('spolecnost')">
				Společnost: {{ basic.spolecnost }}
			</div>
			<div v-if="basic.hasOwnProperty('cena')">
				Cena: {{ basic.cena }}
			</div>
			<div v-if="basic.hasOwnProperty('rychlost')">
				Rychlost: {{ basic.rychlost }}
			</div>
			<div v-if="basic.hasOwnProperty('instalace')">
				Instalace: {{ basic.instalace }}
			</div>
			<div v-if="basic.hasOwnProperty('bonusy')">
				Bonus: {{ basic.bonusy }}
			</div>
			<div v-if="basic.hasOwnProperty('poznamka')">
				Poznámka: {{ basic.poznamka }}
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'NejPripoResult',

	props: {
		results: { type: Array, default: [] },
		loading: { type: Boolean }
	},
}
</script>

<style lang="stylus" scoped>
.first-text
	font-size 20px

.nejpripo-data
	padding-top 10px
	border-bottom 1px solid #4CA5F9
	border-top 1px solid #4CA5F9

.company-name
	font-weight bold
	font-size 24px


.nejpripo-vysledek
	display flex
	flex-direction column
	border-bottom 1px dashed #4CA5F9
	border-top 1px dashed #4CA5F9
	padding-bottom 10px
	padding-top 10px

.cetin-vysledek-card
	padding 10px
	background-color white
	border-radius 5px
	margin-right 10px
	margin-bottom 10px

.zmensit
	width 400px

.loading
	height 50px
	padding 0px

.loading-icon
	height 50px
	padding 0px !important
	margin-top -100px !important


@media (max-width 1000px)
	.zmensit
		width 100%

</style>



// WEBPACK FOOTER //
// src/components/search_provider/results/NejPripoResult.vue